import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import QuoteSection from "@/components/sections/QuoteSection";
import FaqSection from "@/components/sections/FaqSection";
import { IMAGES } from "@/data/site";
import { breadcrumbSchema } from "@/lib/schema";

export default function Contato() {
  return (
    <>
      <SEO
        title="Contato | Auto Socorro Pimenta | Guincho 24 Horas em RO e MT"
        description="Fale com a Auto Socorro Pimenta. Telefone (69) 3451-2112 e WhatsApp (69) 99904-0973. Atendimento de guincho 24 horas em Rondônia e Mato Grosso."
        path="/contato"
        schemas={[breadcrumbSchema([{ name: "Início", path: "/" }, { name: "Contato", path: "/contato" }])]}
      />

      <PageHeader
        eyebrow="Contato"
        title={<>Fale conosco<br /><span className="text-brand-red">agora mesmo</span></>}
        subtitle="Estamos disponíveis 24 horas por dia, todos os dias. Solicite seu guincho pelo WhatsApp, ligue ou preencha o formulário abaixo."
        image={IMAGES.heroFleet}
        trail={[{ name: "Início", path: "/" }, { name: "Contato", path: "/contato" }]}
      />

      <QuoteSection />
      <FaqSection />
    </>
  );
}
